import Button from "components/foundation/Button";
import SearchInput from "components/foundation/SearchInput/SearchInput";
import Select from "components/foundation/Select/Select";
import React from "react";
import styled from "styled-components";
import FilterListItem from "./FilterListItem";
import { Controller, useFormContext } from "react-hook-form";
import { ReloadIcon } from "assets/icons";

interface FormData {
  searchType: string;
  search: string;
}

interface FilterSearchProps {
  dropdownList?: { label: string; value: string }[];
  autocomplete?: {
    value: string;
    label: string;
  }[];
  onSearchReset?: () => void;
}

const FilterSearch = ({
  dropdownList,
  autocomplete,
  onSearchReset,
}: FilterSearchProps) => {
  const { control } = useFormContext<FormData>();

  return (
    <FilterListItem
      title="검색 조건"
      style={{
        width: "100%",
      }}
    >
      <FilterSearchLayout>
        {dropdownList && (
          <Controller
            control={control}
            name="searchType"
            render={({ field: { onChange, value } }) => (
              <Select
                style={{
                  minWidth: "17rem",
                }}
                list={dropdownList}
                onValueChange={onChange}
                value={value}
              />
            )}
          />
        )}

        <SearchInput
          placeholder="문서명을 입력해 주세요"
          style={{
            flex: 1,
            display: "flex",
            width: "100%",
          }}
          autocomplete={autocomplete}
        />

        <Button
          variant="secondary"
          size="large"
          style={{
            flexShrink: 0,
          }}
          type="submit"
        >
          검색
        </Button>

        <Button
          variant="tertiary"
          size="large"
          style={{
            flexShrink: 0,
          }}
          leftIcon={<ReloadIcon />}
          type="button"
          onClick={onSearchReset}
        >
          초기화
        </Button>
      </FilterSearchLayout>
    </FilterListItem>
  );
};

export default FilterSearch;

const FilterSearchLayout = styled.div`
  display: flex;
  width: 100%;
  gap: 1rem;
  align-items: center;
  flex: 1;

  p {
    min-width: 10rem;
  }
`;
